// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
const listIsSymbol = {reflectSymbol: () => "list"};
const trackingIdIsSymbol = {reflectSymbol: () => "trackingId"};
const CheckoutTrackingItemIsSymbol = {reflectSymbol: () => "CheckoutTrackingItem"};
const CheckoutTrackingItem = x => x;
const toFillFormTypeCheckoutTra = {fillFormDataType: v => "unknown"};
const newtypeCheckoutTrackingIt = {Coercible0: () => {}};
const hasFieldCheckoutTrackingI = dictHasField => dictHasField;
const eqCheckoutTrackingItem = {
  eq: x => y => (() => {
    if (x.list.tag === "Nothing") { return y.list.tag === "Nothing"; }
    if (x.list.tag === "Just") {
      if (y.list.tag === "Just") {
        if (x.list._1.tag === "Menu") { return y.list._1.tag === "Menu"; }
        if (x.list._1.tag === "CreatorCrossSelling") { return y.list._1.tag === "CreatorCrossSelling"; }
        if (x.list._1.tag === "CartCrossSelling") { return y.list._1.tag === "CartCrossSelling"; }
        return false;
      }
      return false;
    }
    return false;
  })() && x.trackingId === y.trackingId
};
const genericCheckoutTrackingItem = {to: x => x, from: x => x};
const showCheckoutTrackingItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ list: " + (() => {
          if (v.list.tag === "Just") { return "(Just " + Restaumatic$dAnalytics$dTypes$dItemList.showItemList.show(v.list._1) + ")"; }
          if (v.list.tag === "Nothing") { return "Nothing"; }
          $runtime.fail();
        })() + ", trackingId: " + v.trackingId + " " + "}"
      ]
    })(CheckoutTrackingItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCheckoutTrackingItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(listIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dAnalytics$dTypes$dItemList.unscrambleDecodeItemList))(Unscramble.decodeRecordCons(trackingIdIsSymbol)(Data$dUUID.udecodeUUID)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeCheckoutTrackingItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCheckoutTrackingItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(CheckoutTrackingItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(trackingIdIsSymbol)({
      encodeWithOptions: v => Data$dUUID.encodeUUID.encode
    }))(listIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dAnalytics$dTypes$dItemList.encodeItemList.encode(v2._1); }
        $runtime.fail();
      }
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeCheckoutTrackingItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCheckoutTrackingItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CheckoutTrackingItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(trackingIdIsSymbol)({
    decodeWithOptions: v => Data$dUUID.decodeUUID.decode
  })())(listIsSymbol)({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dAnalytics$dTypes$dItemList.decodeItemList.decode)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  CheckoutTrackingItem,
  CheckoutTrackingItemIsSymbol,
  decodeCheckoutTrackingItem,
  encodeCheckoutTrackingItem,
  eqCheckoutTrackingItem,
  genericCheckoutTrackingItem,
  hasFieldCheckoutTrackingI,
  listIsSymbol,
  newtypeCheckoutTrackingIt,
  showCheckoutTrackingItem,
  toFillFormTypeCheckoutTra,
  trackingIdIsSymbol,
  unscrambleDecodeCheckoutTrackingItem
};
